import { Grid, Paper, Typography } from '@mui/material';
import './contacts.ui.scss';
import { ContactsDto } from '../../../services/dtos/contacts.dto';
import Button from '@mui/material/Button';
import React from 'react';
import { ContactDto } from '../../../services/dtos/contact.dto';

/**
 * Ui pour les pages admins
 * @constructor
 */
export default function ContactsUi(
    props: Readonly<{ contacts: ContactsDto[]; handleClickOpen: (contact: ContactDto) => void }>
) {
    const getDisplayValue = (value?: string): string => {
        if (!value) {
            return 'Non renseigné';
        }

        return value;
    };

    //Retourne la vue
    return (
        <div className="contactsUi">
            {/*Premiere boucle sur tous les contacts avec leur zone*/}
            {props.contacts?.map(section => (
                <section className="contactsUi__section" key={section.category}>
                    <div className="contactsUi__sectionHeader">
                        <Typography variant="h3" className="contactsUi__sectionTitle">
                            {section.category}
                        </Typography>
                    </div>
                    <Grid container spacing={3}>
                        {/*Boucle sur les contacts dans chaque zone*/}
                        {section.contacts?.map(contact => (
                            <Grid
                                key={`${contact.email ?? 'no-email'}-${contact.lastName ?? ''}-${
                                    contact.firstName ?? ''
                                }`}
                                item
                                xs={12}
                                md={6}
                                xl={4}
                            >
                                <Paper className="contactCard">
                                    <div className="contactCard__identity">
                                        <div className="contactCard__identityContent">
                                            <Typography variant="h5" className="contactCard__name">
                                                {getDisplayValue(
                                                    `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim()
                                                )}
                                            </Typography>
                                            <Typography variant="body2" className="contactCard__function">
                                                {getDisplayValue(contact.function)}
                                            </Typography>
                                        </div>
                                    </div>
                                    <div className="contactCard__actions">
                                        <Button
                                            variant={'contained'}
                                            onClick={() => props.handleClickOpen(contact)}
                                            data-testid={'send-mail'}
                                            disabled={!contact.email}
                                            className="contactCard__mailButton"
                                        >
                                            Envoyer un mail
                                        </Button>
                                    </div>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </section>
            ))}
        </div>
    );
}
